import React, { useEffect } from "react";
import firebaseManager from "../../model/Firebase/FirebaseManager";
import Title from "../../pages/Login/Components/title/title.jsx";

const DentsAvailable = () => {
  const getDent = () => {
    firebaseManager.showDentPriceless();
  };

  useEffect(() => {
    getDent();
  }, []);

  function handleClick() {
    window.location = "/dentSelected";
  }

  return (
    <React.Fragment>
      <div id="noData">
        <Title text1="No dents availables" />
      </div>
      <div id="okData" className="d-none">
        <Title text1="You have dents. Press on the dent to select it" />
      </div>
      <div onClick={handleClick} id="dentInfo"></div>
    </React.Fragment>
  );
};

export default DentsAvailable;
